<template>
    <div class="container-fluid m-2 p-3">
         <!-- <div class=" d-flex justify-content-between ">

            <p class="logo display-3">Chats</p>
            <div class="d-flex">
                <i class="logo fa-brands fa-whatsapp "></i>
                <p class="ms-2 display-4 d-flex justify-content-center" style="margin-bottom:0;">Whatsapp</p>
            </div>
        </div> -->
        <!-- Contenido de los chats -->
         
        <div class="row pb-1 pt-1 chat-layout">
            <div class="col-12 col-lg-4 mb-3 mb-lg-0">
                
                <div v-if="ready" class="chats " style="overflow-y: scroll; " >

                    <div class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2">
                        <p class="mb-0 chat-list-title">Chats ({{ chatCount }})</p>
                        <div class="d-flex">
                            <button @click="showNewChat = !showNewChat" class="btn-reload me-2">
                                <i class="fa-solid fa-plus"></i>
                            </button>
                            <button @click="getConversations()" class="btn-reload">
                                <i class="fa-solid fa-rotate-right"></i>
                            </button>
                        </div>
                    </div>

                    <form v-if="showNewChat" @submit.prevent="startNewChat" class="new-chat-form mx-3 mb-2">
                        <input v-model="newChatPhone" type="text" placeholder="Numero con codigo de pais" class="new-chat-input">
                        <input v-model="newChatName" type="text" placeholder="Nombre opcional" class="new-chat-input">
                        <textarea v-model="newChatMessage" placeholder="Mensaje inicial" class="new-chat-message"></textarea>
                        <button :disabled="sendingNewChat" type="submit" class="btn-new-chat">
                            <i class="fa-solid fa-paper-plane"></i>
                            <span>{{ sendingNewChat ? 'Enviando...' : 'Enviar' }}</span>
                        </button>
                    </form>

                    <div v-if="newChatError" class="new-chat-error mx-3 mb-2">
                        {{ newChatError }}
                    </div>

                    <div class="search-chat mx-3 mb-2">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <input v-model="searchTerm" @input="queueSearch" type="text" placeholder="Buscar por nombre, numero o mensaje">
                    </div>

                    <div v-for="(conversation, i) in conversaciones" :key="conversation.id">
                        <div :id="'conv-'+conversation.id" class="conversation row ms-0 chat d-flex justify-content-center align-items-center p-2"
                         @click="selectConversation(conversation.id, conversation, i)">
                            <div class="conversation-click"></div>
                        <div class="col-2">
                            <!-- Aquí puedes poner una imagen de perfil, por ejemplo -->
                            <div class="circle-profile d-flex justify-content-center align-items-center">
                                <i class="fa-solid fa-user"></i>
                            </div>
                        </div>
                        <div class="col-8">
                            <!-- Mostrar el nombre del participante (puedes usar `Participante1` o `Participante2`) -->
                            <p>{{ getConversationName(conversation) }}</p>
                            <!-- O, si prefieres el otro participante: {{ conversation.Participante2 }} -->
                            <!-- Mostrar el último mensaje -->
                            <p class="last-message">{{ getConversationPreview(conversation) }}</p>

                        </div>
                        <div class="col-2 p-1">
                            <!-- Mostrar la hora del último mensaje -->
                            <p style="margin: 0;">{{ conversation.last_message_at ? formatTime(conversation.last_message_at) : (conversation.updated_at
                                ? formatTime(conversation.updated_at ):'' ) }}</p>

                                <div v-if="conversation.unread_count > 0" class="mensaje-pendiente">{{ conversation.unread_count }}</div>
                        </div>
                    </div>
                    </div>
                    <p v-if="chatCount === 0" class="text-center py-4 mb-0 empty-list">No hay conversaciones</p>
                    



                </div>
                <div v-else class="chats d-flex justify-content-center pt-3">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-8 d-flex align-items-center chat-view-col">
                <ChatView
                    :key="`${conversationId}`"
                    :conversation-id="conversationId"
                    style="height: 100%;"
                    :conversacion="conversation"
                    @contact-updated="handleContactUpdated"
                />
            </div>


        </div>

    </div>
</template>

<script>
import Swal from 'sweetalert2';
import Security from '../security';
import ChatView from './ChatView.vue';

export default {
    components: {
        ChatView
    },
    data() {
        return {
            conversaciones: [],
            conversationId: 0,
            conversation: {},
            ready: false,
            pollTimer: null,
            showNewChat: false,
            newChatPhone: "",
            newChatName: "",
            newChatMessage: "",
            newChatError: "",
            sendingNewChat: false,
            searchTerm: "",
            searchTimer: null,
        }
    },
    computed: {
        chatCount() {
            return this.conversaciones?.length || 0;
        },
    },
    
    beforeMount() {
        this.getConversations()
        this.pollTimer = setInterval(() => this.getConversations(false), 7000);
    },
    beforeUnmount() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
        }
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    },
    methods: {
        getConversations(showLoading = true){
            if (showLoading) {
                this.ready = false;
            }
            const query = this.searchTerm.trim()
                ? `?q=${encodeURIComponent(this.searchTerm.trim())}`
                : "";
            return fetch(
                process.env.VUE_APP_API_URL +
                "/api/whatsapp/chats" + query,
                Security.requestOptionsGet()
            )
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    Swal.fire({
                        icon: "error",
                        title: data.message + data.error,
                        showConfirmButton: false,
                        timer: 1500,
                    });

                } else {
                    const conversations = Array.isArray(data?.data?.chats)
                        ? [...data.data.chats]
                        : [];
                    this.conversaciones = conversations

                    this.ready = true



                }
            });
        },
        formatTime(timestamp) {
            const date = new Date(timestamp);
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        getConversationPreview(conversation) {
            const text = conversation?.last_message;
            if (!text) return 'No hay mensajes';
            return text.length > 22 ? `${text.slice(0, 22)}...` : text;
        },
        getConversationName(conversation) {
            return conversation?.contact_name || conversation?.phone_number || conversation?.wa_id || 'Sin nombre';
        },
        queueSearch() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => this.getConversations(false), 250);
        },
        startNewChat() {
            const payload = {
                to: this.newChatPhone.trim(),
                contact_name: this.newChatName.trim(),
                message: this.newChatMessage.trim(),
            };

            this.newChatError = "";
            if (!payload.to || !payload.message) {
                this.newChatError = "Agrega numero y mensaje.";
                return;
            }

            this.sendingNewChat = true;
            fetch(
                process.env.VUE_APP_API_URL + "/api/whatsapp/messages",
                Security.requestOptionsJson("POST", payload)
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        this.newChatError = data.message || "No se pudo enviar el mensaje.";
                        const chat = data?.data?.chat;
                        this.getConversations(false).then(() => {
                            const index = this.conversaciones.findIndex((conversation) => conversation.id === chat?.id);
                            if (index >= 0) {
                                this.$nextTick(() => this.selectConversation(chat.id, this.conversaciones[index], index));
                            }
                        });
                        return;
                    }

                    const chat = data?.data?.chat;
                    this.newChatPhone = "";
                    this.newChatName = "";
                    this.newChatMessage = "";
                    this.showNewChat = false;

                    this.getConversations(false).then(() => {
                        const index = this.conversaciones.findIndex((conversation) => conversation.id === chat?.id);
                        if (index >= 0) {
                            this.$nextTick(() => this.selectConversation(chat.id, this.conversaciones[index], index));
                        }
                    });
                })
                .catch(() => {
                    this.newChatError = "No se pudo conectar con el servidor.";
                })
                .finally(() => {
                    this.sendingNewChat = false;
                });
        },
        selectConversation(id, conversation, index){
            if (document.getElementById('conv-' + this.conversationId)) {
                document.getElementById('conv-' + this.conversationId).classList.remove("chat-active");
            }
            this.conversationId = id
            this.conversation = conversation

            const selectedConversation = document.getElementById('conv-' + id);
            if (selectedConversation) {
                selectedConversation.classList.add("chat-active");
            }

            this.conversaciones[index].unread_count = 0
        },
        handleContactUpdated(chat) {
            if (!chat?.id) {
                return;
            }

            const index = this.conversaciones.findIndex((conversation) => conversation.id === chat.id);
            if (index >= 0) {
                this.conversaciones[index] = {
                    ...this.conversaciones[index],
                    ...chat,
                };
            }

            if (this.conversationId === chat.id) {
                this.conversation = {
                    ...this.conversation,
                    ...chat,
                };
            }
        }
    }
}
</script>

<style scoped>
.container-fluid {
    height: 85vh;
    border-radius: 15px;
    background: #606c88;
    background: -webkit-linear-gradient(0deg, #606c88 0%, #3f4c6b 100%);
    background: linear-gradient(0deg, #606c88 0%, #3f4c6b 100%);
}
.chat-layout {
    height: 100%;
}

.logo {
    font-size: 35px !important;
    color: white;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center
}

.chats {
    height: 78vh;
    background-color: #34405c;
    /* border: 2px solid #727294; Borde de 2px de grosor y color verde */
    border-radius: 7px;
    /* Esquinas redondeadas */
}

.chat {
    color: white;
    font-size: 14px;
    width: 100%;
    background-color: #34405c;
}

p {
    color: white;
}

.chat:hover {
    background-color: #6f788c91;
}
.chat:active {
    background-color: #5e667791;
}
.chat-active {
    background-color: #4b515d91;
}

.circle-profile {
    color: #7389c1;

    width: 40px;
    /* Ancho del círculo */
    height: 40px;
    /* Alto del círculo */
    border-radius: 50%;
    /* Hacer las esquinas redondeadas al 50% */
    background-color: #3498db52;
    /* Color de fondo, puedes cambiarlo */
}

.last-message {
    
    color: #88898b;
    margin: 0;
}

.conversation{
    cursor: pointer;
} 


/* Scroll */

/* Scroll personalizado para navegadores basados en Webkit */
::-webkit-scrollbar {
  width: 12px; /* Ancho del scroll vertical */
  height: 12px; /* Alto del scroll horizontal */
}

::-webkit-scrollbar-track {
  background: #ffffff00; /* Fondo del track */
  border-radius: 10px; /* Bordes redondeados */
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(45deg, #2E3951, #2575fc); /* Color degradado del scroll */
  border-radius: 10px; /* Bordes redondeados */
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(45deg, #2E3951, #1e6ae6); /* Cambio de color al pasar el mouse */
}

/* Scroll personalizado para Firefox */
* {
  scrollbar-width: thin; /* Grosor del scrollbar */
  scrollbar-color: #2E3951 #ffffff1b; /* Color del thumb y track */
}

/* Scroll dentro de un contenedor específico */
.scroll-container {
  /* max-height: 400px; Altura máxima del contenedor */
  overflow-y: auto; /* Activar scroll vertical */
  /* padding: 10px; Espaciado interno */
  /* border: 1px solid #ddd; Bordes del contenedor */
  border-radius: 8px; /* Bordes redondeados */
  /* background-color: #fff; Fondo del contenedor */
  width: 100%;
  margin: 0;
}
.btn-reload{
    margin: 0;
    border-radius: 5px;
    border: 0px;
    background-color: #3c4763;
    padding-inline: 15px;
    padding-block: 5px;
}
.chat-list-title {
    color: white;
    font-weight: 600;
    font-size: 16px;
}
.empty-list {
    color: #cbd3e6;
}
.btn-reload:hover{

    background-color: #434e6b;

}
.btn-reload:active{

    background-color: #515e81;

}

.new-chat-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px;
    background-color: #2e3951;
    border-radius: 7px;
}

.new-chat-input,
.new-chat-message {
    width: 100%;
    border: 0;
    border-radius: 5px;
    background-color: #434e6b;
    color: white;
    font-size: 13px;
    padding: 8px;
}

.new-chat-message {
    min-height: 70px;
    resize: vertical;
}

.new-chat-input::placeholder,
.new-chat-message::placeholder {
    color: #b9c2da;
}

.btn-new-chat {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 0;
    border-radius: 5px;
    background-color: #6f85bc;
    color: white;
    padding: 8px 10px;
    font-size: 13px;
}

.btn-new-chat:hover {
    background-color: #85a1ee;
}

.btn-new-chat:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.new-chat-error {
    color: #ffd0d0;
    background-color: rgba(120, 35, 35, 0.35);
    border-radius: 5px;
    padding: 8px;
    font-size: 13px;
}

.search-chat {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #2e3951;
    color: #b9c2da;
    border-radius: 7px;
    padding: 8px 10px;
}

.search-chat input {
    width: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    color: white;
    font-size: 13px;
}

.search-chat input::placeholder {
    color: #b9c2da;
}

.mensaje-pendiente{
    color: #7389C1;
}
.chat-view-col {
    height: 78vh;
}

@media (max-width: 991px) {
    .container-fluid {
        height: auto;
        min-height: 85vh;
    }

    .chat-layout {
        height: auto;
    }

    .chats,
    .chat-view-col {
        height: 55vh;
    }
}
</style>
